import { FunctionalAnalysesArea } from './functional-analyses-area';

export class FunctionalCharacteristicType {
  financialTypeId: number;
  sortOrder: number;
  name: string;
  functionalAnalysisArea: FunctionalAnalysesArea;
}
